import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3 mb-lg-4\"><h3 class=\"mb-0\">Tasks Overview</h3><select class=\"form-select month-select form-control p-0 h-auto border-0 w-90\" style=\"background-position:right 0 center;\" aria-label=\"Default select example\"><option selected>Last 7 Days</option><option value=\"1\">This Month</option><option value=\"2\">This Year</option></select></div><div id=\"tasks_overview3\"></div>", 2)),
      (_ctx.isClient)
        ? (_openBlock(), _createBlock(_component_apexchart, {
            key: 0,
            type: "pie",
            height: "150",
            options: _ctx.supportOverview,
            series: _ctx.overview
          }, null, 8, ["options", "series"]))
        : _createCommentVNode("", true)
    ])
  ]))
}